import { render, staticRenderFns } from "./NewItemComposition.vue?vue&type=template&id=0f797589&scoped=true&"
import script from "./NewItemComposition.vue?vue&type=script&lang=js&"
export * from "./NewItemComposition.vue?vue&type=script&lang=js&"
import style0 from "./NewItemComposition.vue?vue&type=style&index=0&id=0f797589&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f797589",
  null
  
)

export default component.exports